<side-panel [stepData]="stepData">
    <ng-template let-rowDetail #contentSidePanel>
        <div class="configuration-fields" *ngIf="rowDetail.name=='Nome'">
            <div class="content">
                <form [formGroup]="form" nz-form nzLayout="vertical">
                    <nz-form-item>
                        <nz-form-label nzRequired>Título</nz-form-label>
                        <nz-form-control>
                            <input nz-input type="text" formControlName="title">
                        </nz-form-control>
                    </nz-form-item>
                    <nz-form-item>
                        <nz-form-label>Tempo de Atualização</nz-form-label>
                        <nz-form-control>
                            <input nz-input type="number" formControlName="refresh">
                        </nz-form-control>
                    </nz-form-item>
                    <nz-collapse>
                        <nz-collapse-panel nzHeader="Permissões" [nzActive]="true">
                            <div class="more-options" formGroupName="options">
                                <label class="switch-option">
                                    <nz-switch formControlName="showPagination"></nz-switch>
                                    Paginar Grade?
                                </label>
                                <label class="switch-option">
                                    <nz-switch formControlName="canExport"></nz-switch>
                                    Exportar para Csv?
                                </label>
                                <label class="switch-option">
                                    <nz-switch formControlName="canClipboard"></nz-switch>
                                    Permite Copiar Linhas?
                                </label>
                            </div>
                        </nz-collapse-panel>
                    </nz-collapse>
                    <div class="more-options-color" formGroupName="options">
                        <nz-form-item>
                            <nz-form-label>Expressão de Estilo das Linhas</nz-form-label>
                            <nz-form-control>
                                <nz-input-group [nzSuffix]="helpTpl">
                                    <textarea nz-input
                                        placeholder="Regra de Cor"
                                        aria-label="Regra de Cor"
                                        class="color-formula"
                                        formControlName="colorLinesFormula" name="lo"></textarea>
                                </nz-input-group>
                                <ng-template #helpTpl>
                                    <span nz-icon nzType="question-circle" class="help-icon"
                                        nz-tooltip nzTooltipTitle="Inserir exemplo de fórmula"
                                        (click)="printHelp()"></span>
                                </ng-template>
                            </nz-form-control>
                        </nz-form-item>
                    </div>
                </form>
            </div>
        </div>
        <div class="configuration-fields" *ngIf="rowDetail.name=='query'">
            <query-executor [usePopup]="false" [query]="query" (queryChange)="onQueryChange($event)"
                [showObject]="false" [testMode]="true"></query-executor>
            <suspended-menu *ngIf="filters" title="Filtros" [show]="true" [data]="filters" dropprefix='{@'
                dropsufix='}' heigth="170"></suspended-menu>
        </div>
        <div class="configuration-fields" *ngIf="rowDetail.name=='field'">
            <ng-container #outlet>
            </ng-container>
            <ng-template #content>
                <form [formGroup]="form" *ngIf="editFace">
                    <form-item-component
                            [formulario]="null"
                            [formConfiguration]="formItemConfiguration"
                            [editData]="editData"
                            (saving)="onSavingArray($event)"
                            (canceling)="onCanceling($event)">
                    </form-item-component>
                </form>
                <div [hidden]="editFace" class="grid-face">
                    <div class="fields-toolbar">
                        <button nz-button nzShape="circle" nzType="primary"
                            nz-tooltip nzTooltipTitle="Adicionar" (click)="add()">
                            <span nz-icon nzType="plus"></span>
                        </button>
                        <button nz-button nzShape="circle" nzDanger
                            nz-tooltip nzTooltipTitle="Remover" (click)="remove()">
                            <span nz-icon nzType="delete"></span>
                        </button>
                        <div class="fields-toolbar__spacer"></div>
                        <button nz-button nzShape="circle" class="fields-toolbar__derive"
                            nz-tooltip nzTooltipTitle="Buscar Colunas da Consulta" (click)="buscaFields()">
                            <span nz-icon nzType="rollback"></span>
                        </button>
                    </div>
                    <div class="fields-grid">
                        <ag-grid-angular
                            style="width: 100%; height: 100%"
                            [class]="(ThemeService.theme)? 'ag-theme-quartz-dark':'ag-theme-quartz'"
                            [rowData]="rowsField"
                            [getRowId]="getRowId"
                            [columnDefs]="displayedColumns"
                            (gridReady)="onGridReady($event)"
                            (rowDoubleClicked)="selectRow($event)"
                            (rowClicked)="eventGridSelect($event)"
                            (columnResized)="onResize($event)"
                            (columnMoved)="onReoder($event)"
                            [localeText]="ls.getCurrentGridLocale()"
                            overlayNoRowsTemplate="Não encontrado nenhum resultado"
                            [rowBuffer]="150"
                            rowSelection="multiple"
                            [pagination]="false"
                            [enableCellTextSelection]="true"
                            [suppressClipboardPaste]="true"
                            multiSortKey="ctrl">
                        </ag-grid-angular>
                    </div>
                </div>
            </ng-template>
        </div>
    </ng-template>
</side-panel>
